import {ProductStatus} from '@services/model/product';
import {UUID} from '@util/types';

export class SearchProductEntry {
  constructor(
    public product: SearchProduct,
    public startup: SearchStartup,
    public cycle: SearchCycle | null,
  ) {}
}

export class SearchProduct {
  constructor(
    public readonly id: string | undefined,
    public readonly name: string,
    public readonly description: string,
    public readonly status: ProductStatus,
    public readonly productGroup: string,
    public readonly created: Date,
    public readonly coverImage?: string,
    public readonly coverImageEntry?: string, // <- this one is an optimized version, use this one if possible
  ) {}
}

export class SearchStartup {
  constructor(
    public id: string | undefined,
    public name: string,
    public logo: string | undefined,
  ) {}
}

export class SearchCycle {
  constructor(
    public readonly id: UUID,
    public readonly name: string,
  ) {}
}

export enum SearchProductSort {
  productCreatedDesc = 'productCreatedDesc',
  productCreatedAsc = 'productCreatedAsc',
  productNameAsc = 'productNameAsc',
  productNameDesc = 'productNameDesc',
  startupNameAsc = 'startupNameAsc',
  startupNameDesc = 'startupNameDesc',
  votesDesc = 'votesDesc',
}

export class SearchProductResponse {
  constructor(
    public readonly total: number,
    public readonly results: SearchProductEntry[],
    public readonly query: ProductQuery, // this one gets added by searchproduct.service
  ) {}
}

export type CycleFilter = UUID | 'none' | 'all';

export class ProductQuery {
  constructor(
    public offset: number,
    public limit: number,
    public cycleFilter: CycleFilter,
    public statusIn: ProductStatus[] | null,
    public userId: string | null,
    public startupId: string | null,
    public productGroupKey: string | null,
    public searchProductSort: SearchProductSort | null,
    public published: boolean | null,
    public verdictFilter: VerdictFilter | null,
    public text: string | null,
    public favorite: boolean | null,
  ) {}

  public static uriEncode(q: ProductQuery): string {
    return encodeURI(JSON.stringify(q));
  }
}

type VerdictFilterType = 'any' | 'noverdict' | 'byverdict';
export type VerdictFilterString = VerdictFilterType | 'up';

export class VerdictFilter {
  constructor(
    public type: VerdictFilterType,
    public companyId?: UUID,
    public verdict?: number,
  ) {}

  static fromString(s: VerdictFilterString, companyId?: UUID): VerdictFilter {
    if (s === 'up') {
      return new VerdictFilter('byverdict', companyId, 1);
    } else if (s === 'any') {
      return new VerdictFilter('any');
    } else if (s === 'noverdict') {
      return new VerdictFilter('noverdict', companyId);
    } else {
      console.assert(false, `could not convert verdict filter string '${s}' to type VerdictFilter`);
      return undefined as any;
    }
  }
}
